<div class="action-section">

  <!-- 🔹 HEADING -->
  <h2 class="page-heading">
    ⚡ Data Quality Check — Start Here
  </h2>

  <!-- 🔹 CARDS -->
  <div class="action-card-container">

    <!-- <div class="action-card" (click)="optimizationClick()">
      <mat-icon>tune</mat-icon>
      <div>
        <h4>Optimization</h4>
        <p>Configure system settings</p>
      </div>
    </div> -->

    <div class="action-card" (click)="clearClick()">
      <mat-icon>clear_all</mat-icon>
      <div>
        <h4>Clear</h4>
        <p>Reset the form data</p>
      </div>
    </div>

    <div class="action-card success" (click)="submitClick()">
      <mat-icon>done</mat-icon>
      <div>
        <h4>Submit</h4>
        <p>Save and process request</p>
      </div>
    </div>

    <div class="action-card info" (click)="viewReport()">
      <mat-icon>visibility</mat-icon>
      <div>
        <h4>View Report</h4>
        <p>Preview output</p>
      </div>
    </div>

    <div class="action-card warning" (click)="openRetrievePopup()">
      <mat-icon>restore</mat-icon>
      <div>
        <h4>Retrieve</h4>
        <p>Fetch previous data</p>
      </div>
    </div>

    <div class="action-card dark" (click)="openUploadPopup()">
      <mat-icon>upload_file</mat-icon>
      <div>
        <h4>Download</h4>
        <p>Export report</p>
      </div>
    </div>

    <div class="action-card report-desk" *ngIf="isAdmin()" (click)="reportDeskClick()">
      <mat-icon>mark_email_unread</mat-icon>
      <div>
        <h4>Report Desk</h4>
        <p>Review & corrections</p>
      </div>
    </div>

  </div>
</div>